import { keyBy, mapValues, orderBy } from "lodash";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IAccessLevel } from "./AccessRuleRenderer";
import "../main.css";

export const ACCESSLEVELS = [
    { level: 1, name: "View" },
    { level: 2, name: "Answer" },
    { level: 4, name: "Delete" },
    { level: 8, name: "Upload" },
    { level: 16, name: "Comment" },
    { level: 32, name: "Unlock" },
    { level: 64, name: "Share" },
    { level: 128, name: "Scopes" },
];

export function accessTypeToAccessLevels(accessType: number): IAccessLevel[] {
    let levels = [] as IAccessLevel[];
    orderBy(ACCESSLEVELS, "level", "desc").forEach((accessLevel) => {
        if (accessType >= accessLevel.level) {
            accessType -= accessLevel.level;
            levels.push(accessLevel);
        }
    });
    return levels;
}

export function questionnaireAccessTypeHasLevel(accessType: number, level: number): boolean {
    return accessTypeToAccessLevels(accessType).some((accessLevel) => accessLevel.level === level);
}

export function accessTypeValueToAccessLevelState(accessTypeValue) {
    return mapValues(keyBy(accessTypeToAccessLevels(accessTypeValue), "level"), () => true);
}

const QuestionnaireAccessTypeSelector = ({ handleChange, value, readonly }: { handleChange?: any; value?: any; readonly?: boolean }) => {
    const navigate = useNavigate();
    const params = useParams();

    const [accessLevels, setAccessLevels] = React.useState(value);

    React.useEffect(() => {
        setAccessLevels(value);
    }, [value]);

    const handleAccessLevelChange = (level) => (e) => {
        let value = e.target.checked;
        let _accessLevels = { ...accessLevels };

        if (value) {
            //add
            if (_accessLevels[level] === undefined) {
                _accessLevels[level] = true;
            }
        } else {
            //remove
            if (_accessLevels[level] !== undefined) {
                delete _accessLevels[level];
            }
        }

        setAccessLevels(_accessLevels);
        handleChange(_accessLevels);
    };

    return (
        <div className="p-2">
            {ACCESSLEVELS.map((accessLevel, key) => (
                <div key={key} className="py-1 flex flex-row gap-2 justify-items-start items-center">
                    <input 
                        type="checkbox" 
                        checked={!!accessLevels[accessLevel.level]} 
                        onChange={handleAccessLevelChange(accessLevel.level)} 
                        disabled={readonly}
                        className="h-4 w-4 text-brand border-gray-300 rounded focus:ring-brand disabled:opacity-80"
                    />
                    <span className="text-blue-500 dark:text-blue-100">{accessLevel.name}</span>
                </div>
            ))}
        </div>
    );
};
export default QuestionnaireAccessTypeSelector;
